import { type ReactNode } from "react";
import { ScrollArea, ScrollBar, cn } from "ui";

interface HorizontalFadeScrollAreaProps {
  className?: string;
  children: ReactNode;
}

// Fades the edges that have more content to scroll to.
export function HorizontalFadeScrollArea(props: HorizontalFadeScrollAreaProps) {
  return (
    <div
      className={cn(
        "horizontal-fade-scroll -mx-1 -mt-1 min-w-0",
        props.className,
      )}
    >
      <ScrollArea>
        {/* The padding keeps overflowing content, like drop indicators,
            visible and leaves room for the scrollbar. The negative margin
            above keeps the content in place. */}
        <div className="flex px-1 pt-1 pb-3">
          {/* Zero-width sticky edges keep the fades at the viewport edges. */}
          <div className="sticky left-0 z-10 w-0 flex-none">
            <div className="horizontal-fade-scroll-start pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-background to-transparent" />
          </div>
          {props.children}
          <div className="sticky right-0 z-10 w-0 flex-none">
            <div className="horizontal-fade-scroll-end pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-background to-transparent" />
          </div>
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
}
